<template>
<div class="content">
  <AppButton size="xs" type="link" with-icon icon-position="left" text="Вернуться на главную" @click="selectPage('index')">
    <template #left><IconDefault name="chevron-left" size="s"/> </template>
  </AppButton>
  <h1 v-if="isMobile">{{ page?.menuTitle }}</h1>
  <div class="text" v-html="page?.data?.previewText"></div>
  <div class="images">
    <div v-if="page?.data?.images" v-for="(image,index) in page.data.images" :key="index">
      <img :src="image?.url" :alt="page.menuTitle">
      <p v-html="image?.title"></p>
    </div>
  </div>
  <div class="text" v-html="page?.data?.bottomText"></div>
  <div class="address-list" v-if="page?.data?.addresses">
    <div class="address-list__title">Адреса винотек:</div>
    <ul class="address-list__list">
      <li v-for="(item, index) in page?.data?.addresses" :key="index" v-html="item"></li>
    </ul>
  </div>
  <AppButton type="link" size="m" with-icon icon-position="right" isUppercase href="index"  text="смотреть коллекцию" @click="selectPage('index')">
    <template #right>
      <IconDefault name="arrow-right-long" :size="'m'" is-circled></IconDefault>
    </template>
  </AppButton>
</div>
</template>
<script setup lang="ts">
import {storeToRefs} from "pinia";
import {usePagesStore} from "@stores/pages";
import {useLayoutStore} from "@stores/layout";

import AppButton from "@components/AppButton/index.vue";
import IconDefault from "@components/AppIcon/index.vue";

defineOptions({
  name:'AppAbout'
});
const layoutStore = useLayoutStore();
const pagesStore = usePagesStore();
const { isMobile } = storeToRefs(layoutStore)
const page = pagesStore.getCurrentPage;
const selectPage = (code:string)=>{
  pagesStore.setPage(code)
}


</script>
<style scoped lang="scss">
  .content{
    padding: var(--space-30) var(--space-60);
    @media screen and (max-width: 769px) {
      padding: var(--space-20);
    }
    h1{
      font-size: var(--font-size-20);
      line-height: var(--font-size-24);
      margin-top: var(--space-30);
    }
    .text{
      white-space: pre-line;
      margin: var(--space-30) 0;
    }
    .images {
      > div{
        margin-bottom: var(--space-30);
        img {
          width: 100%;
          object-fit: contain;
          object-position: center;
          border-radius: var(--border-radius-xxs);
          @media screen and (max-width: 769px) {
            object-fit: cover;
            height: 26rem;
          }
        }
        p {
          color: var(--color-secondary);
          font-size: var(--font-size-14);
          @media screen and (max-width: 769px) {
            font-size: var(--font-size-12);
            line-height: var(--font-size-12);
          }
        }
      }
    }
    .address-list{
      margin-top: var(--space-48);
      &__title{
        margin-bottom: var(--space-16);
      }
      &__list{
        margin-bottom: var(--space-30);
        li{
          margin-bottom: var(--space-6);

          :deep(a){
            text-decoration: underline!important;
          }
        }
      }
    }
  }
</style>